import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StickAtDirective } from "./stick-at.directive";
import { DodoRaisedButtonDirective } from "./dodo-raised-button.directive";
import { DodoSimpleButtonDirective } from "./dodo-simple-button.directive";
import { DodoToggleDirective } from "./dodo-toggle.directive";
import { TooltipDirective } from "./tooltip.directive";
import { OverlayModule } from "@angular/cdk/overlay";
import { TooltipComponent } from "./tooltip.component";
import { CustomScrollDirective } from "./custom-scroll.directive";
import { ClickOutsideDirective } from "./clickoutside.directive";

@NgModule({
	imports: [CommonModule, OverlayModule],
	declarations: [
		StickAtDirective,
		CustomScrollDirective,
		DodoRaisedButtonDirective,
		DodoSimpleButtonDirective,
		DodoToggleDirective,
		TooltipDirective,
		ClickOutsideDirective,
		TooltipComponent
	],
	exports: [
		StickAtDirective,
		CustomScrollDirective,
		DodoRaisedButtonDirective,
		DodoSimpleButtonDirective,
		DodoToggleDirective,
		TooltipDirective,
		ClickOutsideDirective
	],
	// entryComponents: [ TooltipComponent ]
})
export class DodoDirectives {}
